import TextFieldMUI from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, {useState} from 'react';

const AutocompleteSelectMultiple = ({
  disabled,
  formikProps,
  label,
  field,
  lookup,
  fullWidth,
  myLabel,
  user,
  id,
}: AutoCompleteSelectMultipleProps) => {
  const [value, setValue] = useState(undefined);

  const lookupData = lookup.find((x) => x.column === field);
  const {touched, errors}: any = formikProps;

  const helperText = touched[field] && errors[field];
  const error = touched[field] && Boolean(errors[field]);

  if (!lookupData) {
    return null;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  return (
    <Autocomplete
      multiple
      id="tags-standard"
      options={lookupData.values}
      getOptionLabel={(option: any) => `${option.profileDesc} - ${option.spac}`}
      value={value}
      onChange={(_: any, value: any) => {
        if (value !== null) {
          formikProps.setFieldValue('iD_ProfileSpac', value);
          setValue(value);
        } else {
          formikProps.setFieldValue('iD_ProfileSpac', '');
        }
      }}
      renderInput={(params: any) => (
        <TextFieldMUI
          {...params}
          variant="outlined"
          error={error}
          helperText={helperText}
          label={useMyLabel}
          required
          fullWidth={fullWidth}
          disabled={disabled}
        />
      )}
    />
  );
};

interface AutoCompleteSelectMultipleProps {
  //Revisar aca, hay dos anys.
  disabled: boolean;
  formikProps: any;
  type: string;
  label: string;
  field: string;
  lookup: any[];
  fullWidth: boolean;
  myLabel: string;
  user: string;
  id: string;
}

export default AutocompleteSelectMultiple;
